/**
 * String values for use with KeyboardEvent.key
 */
export const keyAlt = "Alt";
export const keyAltGraph = "AltGraph";
export const keyCapsLock = "CapsLock";
export const keyControl = "Control";
export const keyArrowDown = "ArrowDown";
export const keyArrowLeft = "ArrowLeft";
export const keyArrowRight = "ArrowRight";
export const keyArrowUp = "ArrowUp";
export const keyBackspace = "Backspace";
export const keyDelete = "Delete";
export const keyEnd = "End";
export const keyEnter = "Enter";
export const keyEscape = "Escape";
export const keyHome = "Home";
export const keyFunction = "Fn";
export const keyFunctionLock = "FnLock";
export const keyFunction2 = "F2";
export const keyFunction3 = "F3";
export const keyFunction4 = "F4";
export const keyFunction5 = "F5";
export const keyFunction6 = "F6";
export const keyFunction7 = "F7";
export const keyFunction8 = "F8";
export const keyFunction9 = "F9";
export const keyFunction10 = "F10";
export const keyFunction11 = "F11";
export const keyFunction12 = "F12";
export const keyFunction13 = "F13";
export const keyFunction14 = "F14";
export const keyFunction15 = "F15";
export const keyNumLock = "NumLock";
export const keyPageDown = "PageDown";
export const keyPageUp = "PageUp";
export const keyScrollLock = "ScrollLock";
export const keyShift = "Shift";
export const keySpace = " ";
export const keyTab = "Tab";
export const ArrowKeys = {
    ArrowDown: keyArrowDown,
    ArrowLeft: keyArrowLeft,
    ArrowRight: keyArrowRight,
    ArrowUp: keyArrowUp,
};
